import React from 'react';
import { Select} from 'antd';


class BeneficiaryIDTypeSelector extends React.Component {

    render() {
        const idTypes = this.props.idTypes;
        return (
            <div>
                <Select
                    disabled={this.props.disabled}
                    style={{ width: 300 }}
                    style={{ width: 200, ...this.props.style }}
                    size={this.props.size}
                    name={this.props.name}
                    placeholder={this.props.placeholder}
                    optionFilterProp="children"
                    allowClear={true}
                    onChange={this.props.onChange}
                    value ={this.props.value}
                    defaultValue={null}
                 >
                    {idTypes && idTypes.map((idType, idx) => {
                        return <Select.Option value={idType.code} key={idType.code}>{idType.value}</Select.Option>
                    })}
                </Select>
            </div>
        )
    }

}

export default BeneficiaryIDTypeSelector;
